import { Button, Paper, Stack, Text } from '@mantine/core';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { ScopusIdChangeButton } from '@/module/Dashboard/components/ScopusIdChangeButton';
import { ProfileDetails } from '@/module/Dashboard/model/DashboardTypes';

import { useFreezeDate } from '@/feature/utils/hooks/useFreezeDate';

export interface ScopusResearcherSyncProps {
  profileDetails: ProfileDetails;
}

export function ScopusResearcherSync({ profileDetails }: ScopusResearcherSyncProps) {
  const { scopusId } = profileDetails;
  const { t } = useTranslation();
  const { isAfterFreezeDate } = useFreezeDate();

  return (
    <Paper
      component="section"
      aria-label={t('dashboard.cards.scopus')}
      flex={1}
      p="md"
      mih="200px"
    >
      <Stack>
        <Text
          ta="center"
          mr="5px"
          fs={scopusId != null ? undefined : 'italic'}
        >
          Scopus ID: {scopusId ?? t('scopus.unassigned')}
        </Text>
        {scopusId && (
          <Button
            component={Link}
            to="/sync-scopus"
            disabled={isAfterFreezeDate}
          >
            {t('button.import')}
          </Button>
        )}
        <ScopusIdChangeButton scopusId={scopusId} />
      </Stack>
    </Paper>
  );
}
